export default "__VITE_PUBLIC_ASSET__5b94903c__"